module.exports = __webpack_public_path__ + "media/img/trettin-b19da5a16cc63cf63f846c8fba6e5b5f.jpg";